import { Box, MenuItem, Typography } from '@mui/material'
import { HTMLAttributes } from 'react'

import { BoxWithLogo } from 'components/Box'
import { SelectOption, SelectProps } from 'components/Select'

type OptionToMenuItemProps<T> = Pick<SelectProps<T>, 'disabledOptions' | 'labelColor' | 'size'> &
  SelectOption<T> & {
    autocompleteOptionProps?: HTMLAttributes<HTMLLIElement>
  }

export const optionToMenuItem = <T,>({
  autocompleteOptionProps,
  disabledOptions,
  endAdornment,
  label,
  labelColor,
  logo,
  size,
  value,
}: OptionToMenuItemProps<T>): JSX.Element => (
  <MenuItem
    {...autocompleteOptionProps}
    data-cy={`select-option-${value}`}
    disabled={disabledOptions?.includes(value)}
    key={value}
    value={value}
  >
    <BoxWithLogo
      logo={{
        size: 'small',
        svg: logo,
      }}
    >
      <Typography
        data-cy={`select-option-label-${label}`}
        sx={{ color: labelColor?.({ value: value as T }) }}
        variant={size === 'small' ? 'body2' : 'body1'}
      >
        {label}
      </Typography>

      {endAdornment && <Box sx={{ mx: 1 }}>{endAdornment}</Box>}
    </BoxWithLogo>
  </MenuItem>
)
